// extracted by mini-css-extract-plugin
export var statItem = "_km-1";
export var statsRow = "_km-0";